import { createContext } from "react";

const ContextSnackbar = createContext();

export default ContextSnackbar;
